module.exports = __webpack_public_path__ + "img/ico_floating_recomm.a56efba.png";